export default {
    LOKI: {
        DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
        ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
        SET_GLOBAL_LOADING: 'setGlobalLoading',
        SET_LOADING_MESSAGE: 'setLoadingMessage',
        SET_MENU_ACTIONS: 'SET_MENU_ACTIONS',
        SET_NOTIFICATION: 'setNotification',
        SHOW_ALERT: 'showAlert',
        DISABLE_AUTO_SAVING: 'DISABLE_AUTO_SAVING',
        ENABLE_AUTO_SAVING: 'ENABLE_AUTO_SAVING',
        SET_TIMEZONE: 'setTimezone'
    },
    COMUM: {
        SET_EXPANDIR_MENU: 'setExpandirMenu',
        SET_LINK_ARQUIVO: 'setLinkArquivo',
        SET_MENU_AVATAR: 'setMenuAvatar',
        SET_PRODUTO: 'setProduto',
        SET_RETRAIR_MENU: 'setRetrairMenu',
        SET_USUARIO_LOGADO: 'setUsuarioLogado',
        SET_PARAMETROS: 'setParametros',
        SET_ESCONDER_MENU: 'setEsconderMenu',
        SET_MOSTRAR_MENU: 'setMostrarMenu'
    },
    PATRIMONIO: {
        SET_FILTROS_BUSCA_TODOS_PATRIMONIOS: 'setFiltrosBuscaTodosPatrimonios',
        SET_FILTROS_AVANCADOS_TODOS_PATRIMONIOS: 'setFiltrosAvancadosTodosPatrimonios',
        SET_FILTROS_BUSCA_AVANCADA_TODOS_PATRIMONIOS: 'setFIltrosBuscaAvancadaTodosPatrimonios',
        SET_PAGINACAO_BUSCA_TODOS_PATRIMONIOS: 'setPaginacaoBuscaTodosPatrimonios',
        SET_PATRIMONIO: 'setPatrimonio',
        SET_PATRIMONIO_BACKUP: 'setPatrimonioBackup',
        SET_DOCUMENTOS: 'setDocumentos',
        BUSCAR_DOCUMENTOS: 'buscarDocumentos',
        REMOVER_DOCUMENTOS: 'removerDocumentos',
        SET_VISUALIZACAO_LISTAGEM: 'setVisualizacaoListagem',
        RESETA_PAGE: 'resetaPage',
        DOCUMENTO_DESFAZER_SETLAYOUT:'documentoDesfazerSetLayout',
        DOCUMENTO_DESFAZER:'documentoDesfazer',
    },
    CONTA_CONTABIL: {
        SET_FILTROS_BUSCA_TODAS_CONTAS_CONTABEIS: 'setFiltrosBuscaTodasContasContabeis',
        SET_PAGINACAO_BUSCA_TODAS_CONTAS_CONTABEIS: 'setPaginacaoBuscaTodasContasContabeis',
        SET_CONTA_CONTABIL: 'setContaContabil',
    },
    AJUSTE: {
        SET_FILTROS_BUSCA_TODOS_AJUSTES: 'setFiltrosBuscaTodosAjustes',
        SET_PAGINACAO_BUSCA_TODOS_AJUSTES: 'setPaginacaoBuscaTodosAjustes',
        SET_TIPO_AJUSTE: 'setTipoAjuste',
        SET_AJUSTE: 'setAjuste'
    },
    AMORTIZACAO: {
        SET_PATRIMONIOS_AMORTIZADOS: 'setPatrimoniosAmortizados',
    },
    MOVIMENTACAO: {
        SET_MOVIMENTACAO: 'setMovimentacao',
        SET_MOVIMENTACAO_PENDENTES: 'setMovimentacaoPendentes',
        RESETA_PAGE: 'resetaPage',
        SET_FILTROS_BUSCA_TODAS_MOVIMENTACOES: 'setFiltrosBuscaTodasMovimentacoes',
        SET_PAGINACAO_BUSCA_TODAS_MOVIMENTACOES: 'setPaginacaoBuscaTodasMovimentacoes',
        RESETA_EXTRA: 'ResetaExtra',
        DOCUMENTO:{
            SET_DOCUMENTOS_MOVIMENTACOES:'setDocumentosMovimentacoes',
            REMOVER_DOCUMENTOS_MOVIMENTACAOES:'removerDocumentosMovimentacoes',
        },
        BAIXA: {
            RESETA_PAGE_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS: 'resetaPageBuscarTodasMovimentacoesBaixas',
            SET_FILTROS_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS: 'setFiltrosBuscarTodasMovimentacoesBaixas',
            SET_PAGINACAO_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS: 'setPaginacaoBuscarTodasMovimentacoesBaixas',
        },
    },
    DASHBOARD:{
        SET_LICENCAS: 'setLicencas'
    },
    REAVALIACAO: {
        RESETA_PAGE: 'resetaPage',
        SET_FILTROS_BUSCA_TODAS_REAVALIACOES: 'setFiltrosBuscaTodasReavaliacoes',
        SET_PAGINACAO_BUSCA_TODAS_REAVALIACOES: 'setPaginacaoBuscaTodasReavaliacoes'
    }
}
